module.exports = __webpack_public_path__ + "static/media/www.kulttuurikasarminravintolat.fi.2d7a09f7.jpg";